import type { TagDetailItem } from '@/entities/tags/domain/types';

import { TAG_DISTRIBUTION_CONFIG } from './constants';

export const isValidCategory = (categoryName: string): boolean => {
  const lowerName = categoryName.toLowerCase();
  return !TAG_DISTRIBUTION_CONFIG.EXCLUDED_CATEGORIES.some((pattern) => lowerName.includes(pattern.toLowerCase()));
};

export const isValidTag = (tag: TagDetailItem): boolean => {
  return !tag.disabled && !tag.deleted && !tag.deprecated;
};
